import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const carouselImageSettingsFn = /* @__PURE__ */ createRecipe('carousel-image-settings', {}, [])

const carouselImageSettingsVariantMap = {}

const carouselImageSettingsVariantKeys = Object.keys(carouselImageSettingsVariantMap)

export const carouselImageSettings = /* @__PURE__ */ Object.assign(memo(carouselImageSettingsFn.recipeFn), {
  __recipe__: true,
  __name__: 'carouselImageSettings',
  __getCompoundVariantCss__: carouselImageSettingsFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: carouselImageSettingsVariantKeys,
  variantMap: carouselImageSettingsVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, carouselImageSettingsVariantKeys)
  },
  getVariantProps: carouselImageSettingsFn.getVariantProps,
})